import { cloneDeep, times } from 'lodash';
import createTaskType from '../../createTaskType';
import InformationPostersEditor from './Editor';

export default function InformationPosters({ itemTemplateFunc = null, backgroundImageCount = 3 } = {}) {
    return createTaskType({
        id: 'information_posters',
        label: 'Information Posters',
        skill: 'reading_writing',
        v2: true,
        hasRubric: true,

        backgroundImages: {
            count: backgroundImageCount,
            configs: [
                { label: 'Background image 1' },
                { label: 'Background image 2' },
                { label: 'Poster Image' },
            ], },

        editor: InformationPostersEditor,
        createItemsTemplate: itemTemplateFunc || (() => [
            createPostersImageItem({ isExample: true }), ...times(5, createPostersImageItem)
        ]),
        convertToUploadFormat(task, { isNew }) {
            task = cloneDeep(task);

            task.items = task.items.map(x => {
                if (x.stimulus_text === null) { delete x.stimulus_text; }
                if (x.stimulus_image === null) { delete x.stimulus_image; }
                return x;
            })

            return task;
        },

        getKeys: (item) => {
            return item.answers
                .filter(x => x.is_correct_answer)
                .map(x => `Option ${'ABC'[x.order - 1]} - ${x?.key_text ?? x.image_id}`);
        }
    });
}

export function createPostersImageItem({ isExample = false } = {}) {
    return {
        is_example: isExample,
        ...(isExample && { rubric_id: '' }),
        stimulus_text: '',
        answers: times(3, () => ({
            is_correct_answer: false,
            image_id: '',
        }))
    }
}

export function createPostersTextItem({ isExample = false } = {}) {
    return {
        is_example: isExample,
        ...(isExample && { rubric_id: '' }),
        stimulus_image: '',
        answers: times(3, () => ({
            is_correct_answer: false,
            key_text: '',
        }))
    }
}